/**
 * Utility functions for error handling
 */

/**
 * Safely extracts a readable error message from various error types
 * @param error - The error to extract a message from
 * @returns A human-readable error message
 */
export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message
  }
  if (typeof error === "string") {
    return error
  }
  return "An unexpected error occurred"
}
